var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 9.1665H4.16667V5.83317C4.16667 5.374 4.54083 4.99984 5 4.99984H5.83333V5.83317C5.83333 6.2915 6.20833 6.6665 6.66667 6.6665C7.125 6.6665 7.5 6.2915 7.5 5.83317V4.99984H12.5V5.83317C12.5 6.2915 12.875 6.6665 13.3333 6.6665C13.7917 6.6665 14.1667 6.2915 14.1667 5.83317V4.99984H15C15.4592 4.99984 15.8333 5.374 15.8333 5.83317V9.1665ZM15 3.33317H14.1667V2.49984C14.1667 2.0415 13.7917 1.6665 13.3333 1.6665C12.875 1.6665 12.5 2.0415 12.5 2.49984V3.33317H7.5V2.49984C7.5 2.0415 7.125 1.6665 6.66667 1.6665C6.20833 1.6665 5.83333 2.0415 5.83333 2.49984V3.33317H5C3.62167 3.33317 2.5 4.45484 2.5 5.83317V15.8332C2.5 17.2115 3.62167 18.3332 5 18.3332H15C16.3783 18.3332 17.5 17.2115 17.5 15.8332V5.83317C17.5 4.45484 16.3783 3.33317 15 3.33317Z",
    fill: "#B0B3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b405c54dc7f9636dc5d3dc76c88ae374.svg";
export { ForwardRef as ReactComponent };